import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { ScheduledItemCalendarHeaderRow, ScheduledItemCalendarRow } from 'components/Calendar'
import { getCalendarArray } from 'lib/calendar'
import { endOfMonth, startOfMonth } from 'date-fns'

type Props = {
  currentDate: Date
  currentMonth: Date
}

const ScheduledItemCalendar: FC<Props> = (props) => {
  const { currentDate, currentMonth } = props
  const calendar = getCalendarArray(startOfMonth(currentMonth), endOfMonth(currentMonth))

  return (
    <table className={styles.table}>
      <thead>
        <ScheduledItemCalendarHeaderRow />
      </thead>
      <tbody>
        {calendar.map((row, rowNum) => (
          <ScheduledItemCalendarRow key={rowNum} currentDate={currentDate} currentMonth={currentMonth} row={row} />
        ))}
      </tbody>
    </table>
  )
}

export default ScheduledItemCalendar
